export default __webpack_public_path__ + "static/img19-7f9c86211912263180d2816e4f991f25.png";